module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/ai-e446c814c77c0059f80ab1ddc7553a6c.svg";